import { type SchemaDigitalOrderStatus } from '../../openApi';

export const DigitalOrderStatuses: { [K in SchemaDigitalOrderStatus]: K } = {
    NEW: 'NEW',
    PENDING_PAYMENT: 'PENDING_PAYMENT',
    WAIT_FOR_EMAIL_SENDING: 'WAIT_FOR_EMAIL_SENDING',
    COMPLETED: 'COMPLETED',
    CANCELLED: 'CANCELLED',
};
